import { fromMetaStringToNumber } from '@helios/utils'
import { calculateDifference } from '../utils/metadata-columns'

export const formatMetaDataTooltip = (
  metadata: Record<string, unknown>,
): string => {
  const formatted: string[] = []

  if (!metadata) {
    return ''
  }

  const keys = Object.keys(metadata)

  for (const row of keys) {
    formatted.push(`${row}: ${metadata[row]}`)
  }

  return formatted.join('\n')
}

export const formatCombinedMetaDataTooltip = (
  metadata: Record<string, string>,
): string => {
  if (!metadata) {
    return ''
  }

  // clones the metadata object and replaces it with 5 data sets in this specific order
  const sortOrder = [
    'Difference',
    'CWAN Value',
    'Client Value',
    'Predicted Value',
    'Day Difference',
  ]
  const sorted = JSON.parse(JSON.stringify(metadata, sortOrder))

  const formatted: Array<string> | unknown[] = Object.entries(sorted).map(
    ([key, value]) => {
      switch (key) {
        case 'Difference':
          return `${key}: ${fromMetaStringToNumber(
            calculateDifference(sorted),
          )}`
        case 'CWAN Value':
          return `${key}: ${fromMetaStringToNumber(value)}`
        case 'Client Value':
          return `External Value: ${fromMetaStringToNumber(value)}`
        case 'Predicted Value':
        case 'Day Difference':
          return `${key}: ${fromMetaStringToNumber(value)}`
        default:
          return
      }
    },
  )

  return formatted.join('\n') ?? ''
}
